import api from "@/services/api";
import { ENDPOINTS_FUNDING, ENDPOINTS_PAYOUT, ENDPOINTS_TEAM } from "@/services/endpoints";

export const listFundingMethods = () => api.get(ENDPOINTS_FUNDING.list).then((r) => r.data);
export const createFundingMethod = (payload) =>
  api.post(ENDPOINTS_FUNDING.create, payload).then((r) => r.data);
export const setFundingDefault = (id) =>
  api.post(ENDPOINTS_FUNDING.setDefault(id)).then((r) => r.data);
export const removeFundingMethod = (id) =>
  api.delete(ENDPOINTS_FUNDING.remove(id)).then((r) => r.data);

export const listPayoutMethods = () => api.get(ENDPOINTS_PAYOUT.list).then((r) => r.data);
export const createPayoutMethod = (payload) =>
  api.post(ENDPOINTS_PAYOUT.create, payload).then((r) => r.data);
export const verifyPayoutMethod = (id) =>
  api.post(ENDPOINTS_PAYOUT.verify(id)).then((r) => r.data);
export const setPayoutDefault = (id) =>
  api.post(ENDPOINTS_PAYOUT.setDefault(id)).then((r) => r.data);
export const removePayoutMethod = (id) =>
  api.delete(ENDPOINTS_PAYOUT.remove(id)).then((r) => r.data);

export const listTeamInvites = () => api.get(ENDPOINTS_TEAM.list).then((r) => r.data);
export const createTeamInvite = (payload) =>
  api.post(ENDPOINTS_TEAM.create, payload).then((r) => r.data);
export const revokeTeamInvite = (id) =>
  api.delete(ENDPOINTS_TEAM.revoke(id)).then((r) => r.data);
